/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { email } from "@api/Api";

// ** Axios Imports
import axios from "axios";

// email setting
export const getAllEmail = createAsyncThunk(
  "appEmail/getAllEmail",
  async (query) => {
    try {
      return email.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getEmail = createAsyncThunk("appEmail/getEmail", async (id) => {
  try {
    return email.getEmail(id);
  } catch (error) {
    console.error(error);
  }
});

export const addEmail = createAsyncThunk(
  "appEmail/addEmail",
  async (values) => {
    try {
      return email.create(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteEmail = createAsyncThunk(
  "appEmail/deleteEmail",
  async (id) => {
    return email.remove(id);
  }
);

//end of setting

// email Static
export const getAllEmailStatic = createAsyncThunk(
  "appEmail/getAllEmailStatic",
  async (query) => {
    try {
      return email.getAllEmailStatic(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getEmailStatic = createAsyncThunk(
  "appEmail/getEmailStatic",
  async (id) => {
    try {
      return email.getEmailStatic(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const addEmailStatic = createAsyncThunk(
  "appEmail/addEmailStatic",
  async (values) => {
    try {
      return email.createEmailStatic(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteEmailStatic = createAsyncThunk(
  "appEmail/deleteEmailStatic",
  async (id) => {
    return email.removeEmailStatic(id);
  }
);

//end of Static

// email templete
export const getAllEmailTemplete = createAsyncThunk(
  "appEmail/getAllEmailTemplete",
  async (query) => {
    try {
      return email.getAllEmailTemplete(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getEmailTemplete = createAsyncThunk(
  "appEmail/getEmailTemplete",
  async (id) => {
    try {
      return email.getEmailTemplete(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const addEmailTemplete = createAsyncThunk(
  "appEmail/addEmailTemplete",
  async (values) => {
    try {
      return email.createEmailTemplete(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteEmailTemplete = createAsyncThunk(
  "appEmail/deleteEmailTemplete",
  async (id) => {
    return email.removeEmailTemplete(id);
  }
);

export const addEmailStatus = createAsyncThunk(
  "appEmail/addEmailTemplete",
  async (values) => {
    try {
      return email.createEmailStatus(values);
    } catch (error) {
      console.error(error);
    }
  }
);

//end of Templete

export const appEmailSlice = createSlice({
  name: "appEmail",
  initialState: {
    email: [],
    emailStatic: [],
    emailTemplete: [],
    metaData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllEmail.fulfilled, (state, action) => {
        state.metaData = action.payload?.data.metaData;
        state.email = action.payload?.data?.data.length
          ? action.payload?.data.data
          : [];
      })
      .addCase(getAllEmailStatic.fulfilled, (state, action) => {
        state.metaData = action.payload?.data.metaData;
        state.emailStatic = action.payload?.data?.data?.length
          ? action.payload?.data.data
          : [];
      })
      .addCase(getAllEmailTemplete.fulfilled, (state, action) => {
        state.metaData = action.payload?.data.metaData;
        state.emailTemplete = action.payload?.data?.data?.length
          ? action.payload?.data.data
          : [];
      });
  },
});

export default appEmailSlice.reducer;
